
import Vue from 'vue';
import { searchEmails } from '@/api';
import moment from 'moment';

export default Vue.extend({
  name: 'EmailTracker',
  data() {
    return {
      searchQuery: '',
      dateFrom: '',
      dateTo: '',
      menuFrom: false,
      menuTo: false,
      loading: false,
      results: [],
      headers: [
        { text: 'Timestamp', value: 'ts' },
        { text: 'To', value: 'email' },
        { text: 'Subject', value: 'subject' },
        { text: 'Sender', value: 'sender' },
        { text: 'State', value: 'state' },
        { text: 'Opens', value: 'opens' },
        { text: 'Clicks', value: 'clicks' },
      ],
    };
  },
  methods: {
    async performSearch() {
      if (!this.searchQuery) return;
      
      this.loading = true;
      try {
        const data = await searchEmails({
          query: this.searchQuery,
          dateFrom: this.dateFrom ? moment(this.dateFrom).format('YYYY-MM-DD') : undefined,
          dateTo: this.dateTo ? moment(this.dateTo).format('YYYY-MM-DD') : undefined,
        });
        this.results = data;
      } catch (error) {
        console.error('Search failed', error);
      } finally {
        this.loading = false;
      }
    },
    formatDate(ts: number) {
        return moment.unix(ts).format('YYYY-MM-DD HH:mm:ss');
    },
    getStateColor(state: string) {
      switch (state) {
        case 'sent': return 'success';
        case 'bounced': return 'error';
        case 'rejected': return 'error';
        case 'spam': return 'warning';
        case 'soft-bounced': return 'warning';
        default: return 'grey';
      }
    }
  }
});
